import React, { useEffect } from 'react';
import UserLinkTree from './components/UserLinkTree';
import NotFound from './components/NotFound';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Footer from './components/Footer';
import Dashboard from './dashboard/Dashboard';
import QrPage from './pages/Qr/index';
import RecoveryPage from './pages/Recovery';

import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';

import tr_TR from 'antd/locale/tr_TR';
import en_US from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';


// `/` belongs to the static marketing site (landing/dist), which Express serves
// ahead of this bundle — React never mounts there on a normal page load. This
// only catches client-side navigation back to `/` from inside the SPA, and hands
// control to the server with a real request.
const LandingRedirect = () => {
  useEffect(() => {
    window.location.replace('/');
  }, []);

  return null;
}

const App = () => {
  const [t, i18n] = useTranslation();

  const isAuth = {
    token: localStorage.getItem('auth-token')
  }

  console.log("i18n.language", i18n.language)

  // antd's date pickers take month and day names from dayjs, not from ConfigProvider
  const isEnglish = i18n.language.slice(0, 2) == 'en';
  dayjs.locale(isEnglish ? 'en' : 'tr');

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#7355f0',
        },
      }}
      // direction="rtl"
      locale={i18n.language.slice(0, 2) == 'en' ? en_US : tr_TR}
    >

      <Router>
        <div>

          <Switch>
            <Route path="/qr/:code" component={QrPage} />
            <Route path="/recovery/:code" component={RecoveryPage} />
            <Route exact path="/" render={() => (
              isAuth.token ? <Redirect to='/admin' /> : <LandingRedirect />
            )} />
            <Route path="/admin" render={() => (
              isAuth.token ? <Dashboard /> : <Redirect to='/login' />
            )} />
            {/* Old dashboard addresses, kept for bookmarks */}
            <Redirect from="/settings" to="/admin/design" />
            <Redirect from="/edit" to="/admin" />
            <Route path="/signup" component={SignUp} />
            <Route path="/login" component={Login} />
            {/* All other paths need to remain above the username path */}
            <Route path="/:username" component={UserLinkTree} />
            <Route component={NotFound} />
          </Switch>

        </div>
      </Router>

    </ConfigProvider>

  )
}

export default App




